export const BRANDS_LINKS = [
	"kiek-kainuoja-sukurti-etaxi-klona",
	"kiek-kainuoja-sukurti-wolt-klona",
	"kiek-kainuoja-sukurti-citybee-klona",
	"kiek-kainuoja-sukurti-whatsapp-klona",
	"kiek-kainuoja-sukurti-bolt-klona",
	"kiek-kainuoja-sukurti-foodout-klona",
	"kiek-kainuoja-sukurti-airbnb-klona",
	"kiek-kainuoja-sukurti-tinder-klona"
];
